import { StyleFunction, Styles } from "@helpers/hooks/useStyles"
import { TextStyle, ViewStyle } from "react-native"

export interface SharePollModalStyles extends Styles {
    content: ViewStyle
    title: TextStyle
    phoneTitle: TextStyle
    phoneInputWrapper: ViewStyle
    phoneInput: ViewStyle
    scanContainer: ViewStyle
    scanTextContainer: ViewStyle
    scanTitle: TextStyle
    scanDescription: TextStyle
    qrCode: ViewStyle
    subtitle: TextStyle
    iconsWrapper: ViewStyle
    sendButton: ViewStyle
    sendButtonTitle: TextStyle
    shareLinkWrapper: ViewStyle
    spinner: ViewStyle
    spinnerContainer: ViewStyle
    spinnerWrapper: ViewStyle
}

export const sharePollModalStyles: StyleFunction<SharePollModalStyles> = ({
    theme,
    width,
}) => {
    return {
        content: {
            justifyContent: "center",
            paddingHorizontal: 27,
            paddingBottom: 42,
            minWidth: 400,
        },
        title: {
            ...theme.font.sharePollTitle,
            textAlign: "center",
        },
        subtitle: {
            ...theme.font.sharePollSubtitle,
            textAlign: "center",
            paddingTop: 10,
            paddingHorizontal: 20,
        },
        phoneInputWrapper: {
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
        },
        phoneTitle: {
            ...theme.font.sharePollPhoneTitle,
            paddingBottom: 10,
        },
        phoneInput: {
            ...theme.font.phoneNumberCardTextActive,
            textAlign: "center",
            height: 35,
            width: 226,
            borderWidth: 1,
            borderColor: "#ddd",
            borderRadius: 10,
            backgroundColor: theme.color.phoneNumberCardBackground,
            fontSize: 18,
            marginRight: 15,
        },
        scanContainer: {
            flexDirection: "row",
        },
        scanTextContainer: {
            width: 260,
            flexDirection: "column",
            alignItems: "flex-start",
            flex: 1,
            marginRight: 16
        },
        scanTitle: {
            ...theme.font.sharePollScanTitle,
            paddingBottom: 8,
        },
        scanDescription: {
            ...theme.font.sharePollScanDescription,
            textAlign: "left",
        },
        qrCode: {},
        iconsWrapper: {
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-around",
            alignItems: "center",
            paddingHorizontal: 30,
            paddingTop: 35,
            paddingBottom: 5,
        },
        sendButton: {
            width: 100,
        },
        sendButtonTitle: {
            fontSize: 16,
        },
        shareLinkWrapper: {
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: 26,
            paddingTop: 30,
        },
        spinnerWrapper: {
            width: "100%",
            paddingVertical: 100,
        },

        spinnerContainer: {
            flex: 1,
            justifyContent: "center",
            width: "100%",
        },
        spinner: {
            width: 80,
            height: 80,
            alignSelf: "center",
        },
        WEB: {
            content: {
                width: 400,
            },
            phoneInput: {
                ...theme.shadow.phoneNumberInputShadow.web,
            },
            shareLinkWrapper: {
                paddingTop: 5,
            },
            spinnerWrapper: {
                width: 325,
                paddingVertical: 100,
            },
        },
        MOBILE: {
            phoneInput: {
                ...theme.shadow.phoneNumberInputShadow.web,
            },
            iconsWrapper: {
                paddingHorizontal: 0,
            },
        },
        NATIVE: {
            content: {
                maxHeight: 400,
            },
            iconsWrapper: {
                paddingHorizontal: 0,
            },
        },
    }
}
